import axios from 'axios';
import { SERVER_URL } from './secret';

const axiosInstance = axios.create({
  baseURL: SERVER_URL,
  timeout: 60 * 1000,
  maxRedirects: 0,
});

export default axiosInstance;